var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
export function Loading(_a) {
    var width = _a.width, height = _a.height, isText = _a.isText;
    var t = useTranslation().t;
    if (isText) {
        return _jsx("option", { children: t('loadingData') });
    }
    return (_jsx("div", __assign({ className: "twc-flex twc-justify-center twc-items-center" }, { children: _jsx("img", { src: process.env.REACT_APP_LOADER, alt: "loading", width: width || 75, height: height || 75 }) })));
}
